<a mat-button [matMenuTriggerFor]="languageMenu"
   [matTooltip]="'language.choose' | translate"
   [matTooltipDisabled]="layoutService.isLargeScreen()">
    <mat-icon>language</mat-icon>
    <span *breakpoints="[ScreenSize.LARGE]" class="language">{{ `language.${language()}` | translate }}</span>
    <mat-icon iconPositionEnd>expand_more</mat-icon>
</a>
<mat-menu #languageMenu='matMenu' xPosition="before" yPosition="below">
    @for (languageEntry of availableLanguages | keyvalue; track $index) {
        <button mat-menu-item (click)="selectLanguage(languageEntry.key)">
            {{ languageEntry.value.translationKey | translate }}
        </button>
    }
</mat-menu>
